import { useMemo } from "react";

import type { ForNodeType } from "@/components/features/_model/types";

import { CheckboxField } from "@/components/ui/form/fields/check-box-field/check-box";

type Props = {
	multiSubOptionSelectable: ForNodeType<boolean>;
	onSetMultiSubOptionSelectable: (input: boolean) => void;
};

export const QuestionOptionMultiSubOptionSelectable = ({
	multiSubOptionSelectable,
	onSetMultiSubOptionSelectable,
}: Props) => {
	/**
	 * 旧版のフロントで multiSubOptionSelectable を参照する際に反転させている。
	 * @see {@link https://github.com/CHILLNN-Inc/chillnn-IA-host/blob/0e4ae62cf7563e0912cc02bd9d9c3f4993cce735/host-nuxt/client/components/Organisms/Questions/QuestionSubOptions/index.vue#L104 | Host Nuxt(Github)}
	 */
	const multiSubOptionNotSelectable = useMemo(
		() => !multiSubOptionSelectable.value,
		[multiSubOptionSelectable.value],
	);

	return (
		<div className="grid gap-4">
			<CheckboxField
				value={multiSubOptionNotSelectable}
				label="1度の予約で1つのサブオプションしか選択できないようにする"
				handleChange={onSetMultiSubOptionSelectable}
				errorMessage={multiSubOptionSelectable.error}
			/>

			<div className="text-sm text-caption-50">
				<p>こちらを選択すると、 ゲストが複数のサブオプションのうち一つだけを選択できるようになります。</p>
				<p>※日ごとの場合、日ごとに異なるサブオプションを選択することが可能です。</p>
			</div>
		</div>
	);
};

QuestionOptionMultiSubOptionSelectable.displayName = "QuestionOptionMultiSubOptionSelectable";
